/**
 * Typed permission code constants mirroring backend/src/Crm.Domain/Identity/Permissions.cs.
 * Keep in sync with that file — codes are stored verbatim in the JWT `perm` claim.
 */
export const Permissions = {
  Leads: {
    View: 'Leads.View',
    Create: 'Leads.Create',
    Update: 'Leads.Update',
    Delete: 'Leads.Delete',
    Convert: 'Leads.Convert',
  },
  Clients: {
    View: 'Clients.View',
    Create: 'Clients.Create',
    Update: 'Clients.Update',
    Archive: 'Clients.Archive',
  },
  Contacts: {
    Manage: 'Contacts.Manage',
  },
  Quotes: {
    View: 'Quotes.View',
    Create: 'Quotes.Create',
    Update: 'Quotes.Update',
    Delete: 'Quotes.Delete',
    Send: 'Quotes.Send',
    Approve: 'Quotes.Approve',
  },
  Invoices: {
    View: 'Invoices.View',
    Create: 'Invoices.Create',
    Issue: 'Invoices.Issue',
    Send: 'Invoices.Send',
    Cancel: 'Invoices.Cancel',
    Rectify: 'Invoices.Rectify',
  },
  Payments: {
    View: 'Payments.View',
    Manage: 'Payments.Manage',
  },
  Expenses: {
    View: 'Expenses.View',
    Manage: 'Expenses.Manage',
  },
  Documents: {
    View: 'Documents.View',
    Manage: 'Documents.Manage',
  },
  Users: {
    Manage: 'Users.Manage',
  },
  Roles: {
    Manage: 'Roles.Manage',
  },
  Settings: {
    Manage: 'Settings.Manage',
  },
  Audit: {
    View: 'Audit.View',
  },
  Reports: {
    View: 'Reports.View',
    Generate: 'Reports.Generate',
  },
  Notifications: {
    View: 'Notifications.View',
  },
} as const;
